export enum DocumentsActionType {
  SetState = 'DOCS.SET_STATE',
  GET_DOCS = 'DOCS.GET_DOCS',
  GET_DOCS_ITEM = 'DOCS.GET_DOCS_ITEM',
}
